import type { VoidFunctionComponent } from 'react';

import { useOrganizationPackageLabels } from '../../../../../../../../hooks/api/packageLabels';
import { selectOptionFactory } from '../../../../../../../../utils';
import FilterCardMultiSelect from '../../../../../../../generic/Filter/FilterCardMultiSelect';
import type { SelectOption, SetState } from '../../../../../../../../types';

type Props = {
  packageLabels: SelectOption[];
  setPackageLabels: SetState<SelectOption[]>;
};

/**
 * Package labels filter which allows the user to filter dependencies by package labels.
 * Uses the useOrganizationPackageLabels hook to obtain a list of available labels.
 */
export const PackageLabelsExclusion: VoidFunctionComponent<Props> = ({ packageLabels, setPackageLabels }) => {
  // Load org package labels with the useOrganizationPackageLabels hook.
  const { data: labelsResponse, isLoading: areLabelsLoading } = useOrganizationPackageLabels();
  const labels = labelsResponse?.packageLabels ?? [];
  const isDisabled = labels.length === 0;

  // Convert the available and selected labels to SelectOptions.
  const availableLabels = labels.map(
    (label) => selectOptionFactory(label.name),
  );
  const selectedLabels = packageLabels.map(
    (label) => selectOptionFactory(label.label),
  );

  return (
    <FilterCardMultiSelect
      label="Exclude Package Labels"
      placeholder={areLabelsLoading ? 'Loading...' : 'Select one or more...'}
      options={availableLabels}
      values={selectedLabels}
      onChange={(selectedValues) => setPackageLabels(selectedValues as SelectOption[])}
      isDisabled={isDisabled}
    />
  );
};
